import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Subject } from 'rxjs';
import { AddMappingModel } from '../models/AddMappingModel';

import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../submission.module.config';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';

@Component({
  selector: 'app-add-vocabulary-mapping-dialog',
  templateUrl: './add-vocabulary-mapping-dialog.component.html',
  styleUrls: ['./add-vocabulary-mapping-dialog.component.scss']
})
export class AddVocabularyMappingDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  category: string;
  submittingEntityKey: string;
  submitterCode: string;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  addMapplingActionIdentifier:string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  constructor(private store: Store<any>,
              public dialogRef: MatDialogRef<AddVocabularyMappingDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              private actions$: Actions) {
    this.category = data.errorContext;
    this.submittingEntityKey = data.submittingEntityKey;
    this.submitterCode = data.errorValue;
    this.addForm = formBuilder.group({
      submitterCode: [{value: data.errorValue, disabled: true}],
      vocabLookup: ['', Validators.required]
    });
  }

  add() {
    var model = new AddMappingModel();
    model.category = this.category;
    model.vocabLookup = this.addForm.value.vocabLookup;
    model.submitterCode = this.submitterCode;
    model.submittingEntityKey = this.submittingEntityKey;
    var addMapplingAction = new actions.AddAction(ModuleConfiguration.moduleName, AddMappingModel, { model: model });
    this.addMapplingActionIdentifier = addMapplingAction.identifier;
    this.store.dispatch(addMapplingAction);
  }

  close() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.actions$.ofType(actions.addSuccessType<AddMappingModel>(ModuleConfiguration.moduleName, AddMappingModel))
      .takeUntil(this.destroyed$)
      .subscribe((a: actions.AddSuccessAction<AddMappingModel>) => {
        this.close();
      });
    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.addMapplingActionIdentifier && a.payload.action.identifier === this.addMapplingActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/submission/components/add-vocabulary-mapping-dialog.component.ts